import React, { useEffect, useState } from 'react'
import api from '../services/api'
import CidadeSelect from '../components/CidadeSelect'

interface NaturezaItem {
  tno_cod: number
  tno_cdf: number
  tno_nat: string
  tno_des: string
  ope_cod: string
  ope_des: string
}

interface NaturezaDetalhe {
  tno_cod: number
  tno_cdf: number
  tno_des: string
  tno_dsc: string
  tno_nat: string
  ope_cod: string
  ope_des: string
  tno_loc: string
  tno_ipiicm: string
  tno_ctp: string
  tno_cta: string
  tno_ctb: string
  tno_valctb: string
  tno_texcod: number
  tno_bst: string
  tno_dc: string
  tno_tic: string; tno_tic_des: string; tno_bic: string; tno_aic: string; tno_pdif: string
  tno_tip: string; tno_tip_des: string; tno_bip: string; tno_aip: string
  tno_tpi: string; tno_tpi_des: string; tno_bpi: string; tno_api: string; tno_dpi: string
  tno_tpi_f: string; tno_bpi_f: string
  tno_tcf: string; tno_bcf: string; tno_acf: string; tno_dcf: string
  tno_tcf_f: string; tno_bcf_f: string
  tno_tcs: string; tno_bcs: string; tno_acs: string
  tno_csa: string
  tno_rpc: string
  tno_tir: string; tno_bir: string; tno_air: string; tno_rir: string
  tno_tin: string; tno_bin: string; tno_ain: string; tno_rin: string; tno_min: string; tno_sin: string
  tno_tis: string; tno_bis: string; tno_ais: string; tno_ris: string
  tno_cidco1: number; cidade_des: string; cid_codmun: number
  tno_dif: string; tno_fcp: string
  tno_alitri: string
}

function badgeCfop(cdf: number) {
  const s = String(cdf)[0]
  if (s === '1' || s === '2' || s === '3') return { label: 'Entrada', cls: 'badge-cfop badge-cfop--5' }
  if (s === '5') return { label: 'Saída Estadual', cls: 'badge-cfop badge-cfop--5' }
  if (s === '6') return { label: 'Saída Interestadual', cls: 'badge-cfop badge-cfop--6' }
  if (s === '7') return { label: 'Saída Exterior', cls: 'badge-cfop badge-cfop--7' }
  return { label: 'Outro', cls: 'badge-cfop badge-cfop--x' }
}

interface Opcao { value: string; label: string }

const OPCOES_SIM_NAO: Opcao[] = [
  { value: 'S', label: 'Sim' },
  { value: 'N', label: 'Não' },
]

const OPCOES_TIPO_NATUREZA: Opcao[] = [
  { value: '1', label: 'Entradas' },
  { value: '2', label: 'Transferências' },
  { value: '3', label: 'Saída' },
]

const OPCOES_COMERCIO_SERVICO: Opcao[] = [
  { value: 'C', label: 'Comércio' },
  { value: 'S', label: 'Serviço' },
]

const OPCOES_CONTABILIZA_LIVROS: Opcao[] = [
  { value: 'S', label: 'Ambos' },
  { value: 'C', label: 'Somente Contábil' },
  { value: 'N', label: 'Somente Livro' },
  { value: 'V', label: 'Nenhum' },
]

const OPCOES_MODELO: Opcao[] = [
  { value: '', label: 'Não se Aplica' },
  { value: 'E', label: 'Estadual' },
  { value: 'M', label: 'Municipal' },
  { value: 'U', label: 'Intermunicipal' },
  { value: 'S', label: 'Interestadual' },
  { value: 'I', label: 'Internacional' },
]

const OPCOES_ISENTO_TRIBUTADO: Opcao[] = [
  { value: 'I', label: 'Isento' },
  { value: 'T', label: 'Tributado' },
]

const OPCOES_ISENTO_TRIBUTADO_NUM: Opcao[] = [
  { value: '0', label: 'Isento' },
  { value: '1', label: 'Tributado' },
]

const OPCOES_RETEM_PIS_COFINS_CSLL: Opcao[] = [
  { value: 'N', label: 'Não - Sem Retenção' },
  { value: 'S', label: 'Sim - Cfe Base e Alíquota Informados nos Parâmetros' },
  { value: 'F', label: 'Sim - Com Alíquota Fixa em 4,65% (PIS 0,65% + COFINS 3% + CSLL 1%)' },
]

const tipoNaturezaTexto: Record<string, string> = Object.fromEntries(OPCOES_TIPO_NATUREZA.map(o => [o.value, o.label]))
const tipoNatureza = (v?: string) => tipoNaturezaTexto[(v ?? '').trim()] ?? (v?.trim() ? v : '—')

const CORES_TIPO_NATUREZA: Record<string, { bg: string; cor: string; borda: string }> = {
  '1': { bg: '#dbeafe', cor: '#1e40af', borda: '#3b82f6' },
  '2': { bg: '#f3f4f6', cor: '#4b5563', borda: '#9ca3af' },
  '3': { bg: '#fef3c7', cor: '#92400e', borda: '#f59e0b' },
}

function BadgeTipoNatureza({ v }: { v?: string }) {
  const cod = (v ?? '').trim()
  const cor = CORES_TIPO_NATUREZA[cod] ?? { bg: '#f3f4f6', cor: '#4b5563', borda: '#9ca3af' }
  return (
    <span className="badge" style={{ background: cor.bg, color: cor.cor }}>
      {tipoNatureza(v)}
    </span>
  )
}

const LARGURA_SIM_NAO = 90
const ESTILO_LABEL: React.CSSProperties = { display: 'block', minHeight: '2.5em', lineHeight: 1.2 }

function CampoSelect({ label, value, options, width, onChange, destaque }: {
  label: string; value: string | undefined; options: Opcao[]; width?: number | string
  onChange?: (v: string) => void; destaque?: boolean
}) {
  const valorAtual = (value ?? '').trim()
  const opcoesComValorAtual = options.some(o => o.value === valorAtual)
    ? options
    : [...options, { value: valorAtual, label: valorAtual || '—' }]

  return (
    <div className="field-cad" style={{ width }}>
      <label style={destaque ? { ...ESTILO_LABEL, textAlign: 'center' } : ESTILO_LABEL}>{label}</label>
      <select
        value={valorAtual}
        disabled={!onChange}
        onChange={onChange ? e => onChange(e.target.value) : () => {}}
        style={destaque ? {
          width: '100%', textAlign: 'center', fontWeight: 700, color: '#9a3412',
          background: '#fff7ed', border: '2px solid #f07820', borderRadius: '0.5rem', padding: '0.6rem 0.75rem',
        } : { width: '100%' }}
      >
        {opcoesComValorAtual.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  )
}

function CampoCad({ label, value, width, options, onChange, destaque }: {
  label: string; value: React.ReactNode; width?: number | string; options?: Opcao[]
  onChange?: (v: string) => void; destaque?: boolean
}) {
  if (options) {
    return (
      <CampoSelect
        label={label}
        value={value == null ? '' : String(value)}
        options={options}
        width={width}
        onChange={onChange}
        destaque={destaque}
      />
    )
  }
  if (onChange) {
    return (
      <div className="field-cad" style={{ width }}>
        <label style={ESTILO_LABEL}>{label}</label>
        <input type="text" value={value == null ? '' : String(value)} onChange={e => onChange(e.target.value)} style={{ width: '100%' }} />
      </div>
    )
  }
  return (
    <div className="field-cad" style={{ width }}>
      <label style={ESTILO_LABEL}>{label}</label>
      <input type="text" value={value == null || value === '' ? '—' : String(value)} readOnly disabled style={{ width: '100%' }} />
    </div>
  )
}

function CampoCheckbox({ label, checked, onChange, width }: {
  label: string; checked: boolean; onChange?: (v: boolean) => void; width?: number | string
}) {
  return (
    <div className="field-cad" style={{ width }}>
      <label style={ESTILO_LABEL}>{label}</label>
      <div style={{ display: 'flex', alignItems: 'center', height: '2.35rem' }}>
        <input
          type="checkbox"
          checked={checked}
          disabled={!onChange}
          onChange={onChange ? e => onChange(e.target.checked) : undefined}
          style={{ width: 18, height: 18, cursor: onChange ? 'pointer' : 'default' }}
        />
      </div>
    </div>
  )
}

function Secao({ titulo, cor, corFundo, compact, centralizar, children }: {
  titulo: string; cor: string; corFundo: string; compact?: boolean; centralizar?: boolean; children: React.ReactNode
}) {
  return (
    <div style={{
      background: corFundo, border: '1px solid #eef0f4', borderLeft: `4px solid ${cor}`,
      borderRadius: '0.5rem', padding: compact ? '0.55rem 0.85rem' : '0.9rem 1.1rem',
      marginBottom: compact ? '0.5rem' : '0.9rem',
    }}>
      <h4 style={{
        fontSize: '0.68rem', fontWeight: 700, color: cor, textTransform: 'uppercase',
        letterSpacing: '0.05em', marginBottom: compact ? '0.4rem' : '0.7rem',
        textAlign: centralizar ? 'center' : 'left',
      }}>
        {titulo}
      </h4>
      <div style={{
        display: 'flex', flexWrap: 'wrap', gap: compact ? '0.4rem 0.9rem' : '0.6rem 1rem', alignItems: 'flex-end',
        justifyContent: centralizar ? 'center' : 'flex-start',
      }}>
        {children}
      </div>
    </div>
  )
}

const CAMPOS_EDITAVEIS_GERAL = [
  'tno_nat', 'tno_csa', 'tno_ipiicm', 'tno_bst', 'tno_dc',
  'tno_cta', 'tno_ctp', 'tno_ctb', 'tno_loc', 'tno_valctb', 'ope_cod',
  'tno_tic', 'tno_bic', 'tno_aic', 'tno_pdif', 'tno_tip', 'tno_bip', 'tno_aip', 'tno_tpi', 'tno_bpi', 'tno_api', 'tno_dpi',
  'tno_tpi_f', 'tno_bpi_f', 'tno_tcf', 'tno_bcf', 'tno_acf', 'tno_dcf', 'tno_tcf_f', 'tno_bcf_f',
  'tno_tcs', 'tno_bcs', 'tno_acs', 'tno_tir', 'tno_bir', 'tno_air', 'tno_rpc', 'tno_rir',
  'tno_tin', 'tno_bin', 'tno_ain', 'tno_rin', 'tno_min', 'tno_sin',
  'tno_tis', 'tno_bis', 'tno_ais', 'tno_ris', 'tno_cidco1', 'tno_dif', 'tno_fcp',
] as const

const CAMPOS_CRIACAO = ['tno_cod', 'tno_cdf', 'tno_des', 'tno_dsc'] as const

type FormGeral = Record<typeof CAMPOS_EDITAVEIS_GERAL[number] | typeof CAMPOS_CRIACAO[number], string>

export default function NaturezasOperacao() {
  const [lista, setLista]         = useState<NaturezaItem[]>([])
  const [busca, setBusca]         = useState('')
  const [carregando, setCarregando] = useState(false)
  const [selecionado, setSelecionado] = useState<NaturezaDetalhe | null>(null)
  const [carregandoDetalhe, setCarregandoDetalhe] = useState(false)
  const [aba, setAba] = useState<'geral' | 'tributacao'>('geral')
  const [modoCriar, setModoCriar] = useState(false)
  const [form, setForm]         = useState<FormGeral | null>(null)
  const [salvando, setSalvando] = useState(false)
  const [msgSalvar, setMsgSalvar] = useState('')
  const [opcoesOperacaoComercial, setOpcoesOperacaoComercial] = useState<Opcao[]>([])
  const [opcoesCstIcms, setOpcoesCstIcms] = useState<Opcao[]>([])
  const [opcoesCstIpi, setOpcoesCstIpi] = useState<Opcao[]>([])
  const [opcoesCstPis, setOpcoesCstPis] = useState<Opcao[]>([])
  const [opcoesCstCofins, setOpcoesCstCofins] = useState<Opcao[]>([])
  const [cidadeSel, setCidadeSel] = useState({ cod: '', des: '', ibge: '', uf: '' })

  useEffect(() => {
    api.get('/erp/operacoes-comerciais/lista').then(r => {
      setOpcoesOperacaoComercial(r.data.map((o: any) => ({ value: String(o.ope_cod), label: `${o.ope_cod} - ${o.ope_des}` })))
    })
    api.get('/erp/tricad/lista').then(r => {
      setOpcoesCstIcms(r.data.map((o: any) => ({ value: String(o.tri_cod), label: o.tri_des })))
    })
    api.get('/erp/triipi/lista').then(r => {
      setOpcoesCstIpi(r.data.map((o: any) => ({ value: String(o.cstipi_cod), label: o.cstipi_des })))
    })
    api.get('/erp/tripis/lista').then(r => {
      setOpcoesCstPis(r.data.map((o: any) => ({ value: String(o.cstpis_cod), label: o.cstpis_des })))
    })
    api.get('/erp/tricof/lista').then(r => {
      setOpcoesCstCofins(r.data.map((o: any) => ({ value: String(o.cstcof_cod), label: o.cstcof_des })))
    })
  }, [])

  async function carregarLista(termo: string) {
    setCarregando(true)
    try {
      const r = await api.get('/erp/naturezas-operacao/lista', { params: termo ? { busca: termo } : {} })
      setLista(r.data)
    } finally {
      setCarregando(false)
    }
  }

  useEffect(() => { carregarLista('') }, [])

  useEffect(() => {
    const t = setTimeout(() => carregarLista(busca), 350)
    return () => clearTimeout(t)
  }, [busca])

  function preencherForm(d: NaturezaDetalhe) {
    const f = {} as FormGeral
    for (const campo of CAMPOS_EDITAVEIS_GERAL) f[campo] = (d[campo] as string) ?? ''
    f.tno_cod = String(d.tno_cod)
    f.tno_cdf = String(d.tno_cdf)
    f.tno_des = d.tno_des ?? ''
    f.tno_dsc = d.tno_dsc ?? ''
    setForm(f)
    setCidadeSel({
      cod: d.tno_cidco1 ? String(d.tno_cidco1) : '',
      des: d.cidade_des ?? '',
      ibge: d.cid_codmun ? String(d.cid_codmun) : '',
      uf: '',
    })
  }

  function formularioVazio(): FormGeral {
    const f = {} as FormGeral
    for (const campo of CAMPOS_EDITAVEIS_GERAL) f[campo] = ''
    f.tno_cod = ''
    f.tno_cdf = ''
    f.tno_des = ''
    f.tno_dsc = ''
    return f
  }

  async function selecionar(cod: number) {
    setCarregandoDetalhe(true)
    setAba('geral')
    setMsgSalvar('')
    setModoCriar(false)
    try {
      const r = await api.get(`/erp/naturezas-operacao/${cod}`)
      setSelecionado(r.data)
      preencherForm(r.data)
    } finally {
      setCarregandoDetalhe(false)
    }
  }

  function nova() {
    setSelecionado(null)
    setModoCriar(true)
    setAba('geral')
    setMsgSalvar('')
    setForm(formularioVazio())
    setCidadeSel({ cod: '', des: '', ibge: '', uf: '' })
  }

  function cancelarCriacao() {
    setModoCriar(false)
    setForm(null)
    setMsgSalvar('')
  }

  function setCampo(campo: typeof CAMPOS_EDITAVEIS_GERAL[number] | typeof CAMPOS_CRIACAO[number], valor: string) {
    setForm(f => f && { ...f, [campo]: valor })
  }

  async function salvar() {
    if (!selecionado || !form) return
    if (!window.confirm('Confirma a alteração destes dados diretamente na natureza de operação do ERP?')) return
    setSalvando(true)
    setMsgSalvar('')
    try {
      await api.put(`/erp/naturezas-operacao/${selecionado.tno_cod}`, form)
      setMsgSalvar('Alterações salvas com sucesso.')
      await carregarLista(busca)
      const r = await api.get(`/erp/naturezas-operacao/${selecionado.tno_cod}`)
      setSelecionado(r.data)
      preencherForm(r.data)
    } catch (e: any) {
      setMsgSalvar(e.response?.data?.error ?? 'Erro ao salvar.')
    } finally {
      setSalvando(false)
    }
  }

  async function criar() {
    if (!form) return
    if (!form.tno_cod.trim() || !form.tno_cdf.trim()) {
      setMsgSalvar('Informe ao menos o código e o CFOP.')
      return
    }
    setSalvando(true)
    setMsgSalvar('')
    try {
      const r = await api.post('/erp/naturezas-operacao', form)
      await carregarLista(busca)
      setModoCriar(false)
      await selecionar(r.data.tno_cod)
      setMsgSalvar('Natureza criada com sucesso.')
    } catch (e: any) {
      setMsgSalvar(e.response?.data?.error ?? 'Erro ao criar.')
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
      {/* Lista */}
      <div className="card" style={{ width: 360, flexShrink: 0 }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          marginBottom: '0.9rem', paddingBottom: '0.6rem', borderBottom: '2px solid #eff6ff',
        }}>
          <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#1a6ea8' }}>
            Naturezas da Operação
          </h3>
          <button className="btn btn-primary btn-sm" onClick={nova}>+ Nova</button>
        </div>

        <div className="field" style={{ marginBottom: '0.75rem' }}>
          <input
            type="text"
            placeholder="Buscar por código, CFOP ou descrição..."
            value={busca}
            onChange={e => setBusca(e.target.value)}
          />
        </div>

        {carregando && <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Carregando...</p>}
        {!carregando && lista.length === 0 && (
          <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Nenhuma natureza encontrada.</p>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 560, overflowY: 'auto' }}>
          {lista.map(n => {
            const badge = badgeCfop(n.tno_cdf)
            const corTipo = CORES_TIPO_NATUREZA[(n.tno_nat ?? '').trim()] ?? { bg: '#f3f4f6', cor: '#4b5563', borda: '#9ca3af' }
            const ativo = selecionado?.tno_cod === n.tno_cod
            return (
              <button
                key={n.tno_cod}
                onClick={() => selecionar(n.tno_cod)}
                style={{
                  textAlign: 'left', border: '1px solid #e5e7eb', borderLeft: `4px solid ${corTipo.borda}`,
                  borderRadius: 6, padding: '8px 10px', cursor: 'pointer',
                  background: ativo ? '#eff6ff' : '#f8fafc',
                  borderColor: ativo ? '#1a6ea8' : '#e5e7eb',
                  borderLeftColor: corTipo.borda,
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontWeight: 700, fontSize: '0.82rem' }}>
                    {n.tno_cod} <span style={{ color: '#6b7280', fontWeight: 500 }}>· CFOP {n.tno_cdf}</span>
                  </span>
                  <span className={badge.cls}>{badge.label}</span>
                </div>
                <div style={{ fontSize: '0.8rem', color: '#374151', marginTop: 3 }}>{n.tno_des}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 5 }}>
                  <BadgeTipoNatureza v={n.tno_nat} />
                  {n.ope_des && (
                    <span style={{ fontSize: '0.72rem', color: '#9ca3af' }}>{n.ope_cod} - {n.ope_des}</span>
                  )}
                </div>
              </button>
            )
          })}
        </div>
      </div>

      {/* Detalhe */}
      <div className="card" style={{ flex: 1, minWidth: 0 }}>
        {!selecionado && !modoCriar && !carregandoDetalhe && (
          <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>
            Selecione uma natureza da operação na lista ao lado para ver os detalhes, ou clique em "+ Nova" para criar uma.
          </p>
        )}

        {carregandoDetalhe && <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Carregando detalhes...</p>}

        {(selecionado || modoCriar) && !carregandoDetalhe && form && (
          <>
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
              marginBottom: '1rem', paddingBottom: '0.9rem', borderBottom: '2px solid #eff6ff',
            }}>
              <div>
                {modoCriar ? (
                  <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a6ea8' }}>
                    Nova Natureza da Operação
                  </h3>
                ) : selecionado && (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                      <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a6ea8' }}>
                        {selecionado.tno_cod} — {selecionado.tno_des}
                      </h3>
                      <BadgeTipoNatureza v={selecionado.tno_nat} />
                    </div>
                    <p style={{ fontSize: '0.8rem', color: '#6b7280' }}>CFOP {selecionado.tno_cdf}</p>
                  </>
                )}
              </div>
            </div>

            <div className="fiscal-tabs" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <button type="button"
                className={`fiscal-tab${aba === 'geral' ? ' fiscal-tab--ativa' : ''}`}
                onClick={() => setAba('geral')}>Dados Gerais</button>
              <button type="button"
                className={`fiscal-tab${aba === 'tributacao' ? ' fiscal-tab--ativa' : ''}`}
                onClick={() => setAba('tributacao')}>Tributação</button>
              <span style={{ marginLeft: 'auto', fontSize: '0.78rem', fontWeight: 700, color: '#111827' }}>
                {aba === 'geral' ? 'TNATOPE' : 'TNATOPS'}
              </span>
            </div>

            {aba === 'geral' && form && (
              <div style={{ marginTop: '1rem' }}>
                <Secao titulo="Identificação" cor="#1a6ea8" corFundo="#f7faff">
                  {modoCriar ? (
                    <>
                      <CampoCad label="Código da Natureza" value={form.tno_cod} width={110}
                        onChange={v => setCampo('tno_cod', v.replace(/\D/g, ''))} />
                      <CampoCad label="Código Fiscal (CFOP)" value={form.tno_cdf} width={110}
                        onChange={v => setCampo('tno_cdf', v.replace(/\D/g, ''))} />
                    </>
                  ) : selecionado && (
                    <>
                      <CampoCad label="Código da Natureza" value={selecionado.tno_cod} width={95} />
                      <CampoCad label="Código Fiscal (CFOP)" value={selecionado.tno_cdf} width={95} />
                    </>
                  )}
                  <CampoCad label="Tipo de Natureza" value={form.tno_nat} options={OPCOES_TIPO_NATUREZA} width={150}
                    onChange={v => setCampo('tno_nat', v)} />
                </Secao>

                <Secao titulo="Descrição" cor="#6b7280" corFundo="#fafafa">
                  {modoCriar ? (
                    <>
                      <CampoCad label="Descrição" value={form.tno_des} width="100%"
                        onChange={v => setCampo('tno_des', v)} />
                      <CampoCad label="Descrição/detalhes" value={form.tno_dsc} width="100%"
                        onChange={v => setCampo('tno_dsc', v)} />
                    </>
                  ) : selecionado && (
                    <>
                      <CampoCad label="Descrição" value={selecionado.tno_des} width="100%" />
                      <CampoCad label="Descrição/detalhes" value={selecionado.tno_dsc} width="100%" />
                    </>
                  )}
                  <CampoCad label="Operação Comercial" value={form.ope_cod} options={opcoesOperacaoComercial} width={280}
                    onChange={v => setCampo('ope_cod', v)} />
                </Secao>

                <Secao titulo="Comportamento Fiscal e Contábil" cor="#f07820" corFundo="#fff8f2">
                  <CampoCad label="Comércio/Serviço" value={form.tno_csa} options={OPCOES_COMERCIO_SERVICO} width={150}
                    onChange={v => setCampo('tno_csa', v)} />
                  <CampoCad label="Soma IPI Bs.ICM" value={form.tno_ipiicm} options={OPCOES_SIM_NAO} width={LARGURA_SIM_NAO}
                    onChange={v => setCampo('tno_ipiicm', v)} />
                  <CampoCad label="Integra C/Estoque" value={form.tno_bst} options={OPCOES_SIM_NAO} width={LARGURA_SIM_NAO}
                    onChange={v => setCampo('tno_bst', v)} />
                  <CampoCad label="Pede Cta Estoque" value={form.tno_dc} options={OPCOES_SIM_NAO} width={LARGURA_SIM_NAO}
                    onChange={v => setCampo('tno_dc', v)} />
                  <CampoCad label="Integra Ctas Receb" value={form.tno_cta} options={OPCOES_SIM_NAO} width={LARGURA_SIM_NAO}
                    onChange={v => setCampo('tno_cta', v)} />
                  <CampoCad label="Integra Ctas Pagar" value={form.tno_ctp} options={OPCOES_SIM_NAO} width={LARGURA_SIM_NAO}
                    onChange={v => setCampo('tno_ctp', v)} />
                  <CampoCad label="Valor Contábil" value={form.tno_valctb} options={OPCOES_SIM_NAO} width={LARGURA_SIM_NAO}
                    onChange={v => setCampo('tno_valctb', v)} />
                  <CampoCad label="Contabiliza/Livros" value={form.tno_ctb} options={OPCOES_CONTABILIZA_LIVROS} width={170}
                    onChange={v => setCampo('tno_ctb', v)} />
                  <CampoCad label="Modelo" value={form.tno_loc} options={OPCOES_MODELO} width={160}
                    onChange={v => setCampo('tno_loc', v)} />
                </Secao>
              </div>
            )}

            {aba === 'tributacao' && (
              <div style={{ marginTop: '0.75rem' }}>
                <Secao titulo="CST — ICMS" cor="#1a6ea8" corFundo="#f7faff" compact>
                  <CampoCad label="Tributação" value={form?.tno_tic} options={opcoesCstIcms} width={340}
                    onChange={v => setCampo('tno_tic', v)} />
                  <CampoCad label="Base" value={form?.tno_bic} width={90}
                    onChange={v => setCampo('tno_bic', v)} />
                  <CampoCad label="Alíquota" value={form?.tno_aic} width={90}
                    onChange={v => setCampo('tno_aic', v)} />
                  {form?.tno_tic?.trim() === '51' && (
                    <CampoCad label="Percentual do Diferimento" value={form?.tno_pdif} width={150}
                      onChange={v => setCampo('tno_pdif', v)} />
                  )}
                </Secao>

                <Secao titulo="CST — IPI" cor="#6b7280" corFundo="#fafafa" compact>
                  <CampoCad label="Tributação" value={form?.tno_tip} options={opcoesCstIpi} width={340}
                    onChange={v => setCampo('tno_tip', v)} />
                  <CampoCad label="Base" value={form?.tno_bip} width={90}
                    onChange={v => setCampo('tno_bip', v)} />
                  <CampoCad label="Alíquota" value={form?.tno_aip} width={90}
                    onChange={v => setCampo('tno_aip', v)} />
                </Secao>

                <Secao titulo="CST — PIS" cor="#f07820" corFundo="#fff8f2" compact>
                  <CampoCad label="Tributação" value={form?.tno_tpi} options={opcoesCstPis} width={340}
                    onChange={v => setCampo('tno_tpi', v)} />
                  <CampoCheckbox label="Des.ICMS" checked={form?.tno_dpi === 'S'} width={80}
                    onChange={v => setCampo('tno_dpi', v ? 'S' : 'N')} />
                  <CampoCad label="Base" value={form?.tno_bpi} width={90}
                    onChange={v => setCampo('tno_bpi', v)} />
                  <CampoCad label="Alíquota" value={form?.tno_api} width={90}
                    onChange={v => setCampo('tno_api', v)} />
                  <div style={{ width: '100%', height: 0 }} />
                  <CampoCad label="Tributação (pessoa física)" value={form?.tno_tpi_f} options={opcoesCstPis} width={340}
                    onChange={v => setCampo('tno_tpi_f', v)} />
                  <CampoCad label="Base (pessoa física)" value={form?.tno_bpi_f} width={90}
                    onChange={v => setCampo('tno_bpi_f', v)} />
                </Secao>

                <Secao titulo="CST — COFINS" cor="#1a6ea8" corFundo="#f7faff" compact>
                  <CampoCad label="Tributação" value={form?.tno_tcf} options={opcoesCstCofins} width={340}
                    onChange={v => setCampo('tno_tcf', v)} />
                  <CampoCheckbox label="Des.ICMS" checked={form?.tno_dcf === 'S'} width={80}
                    onChange={v => setCampo('tno_dcf', v ? 'S' : 'N')} />
                  <CampoCad label="Base" value={form?.tno_bcf} width={90}
                    onChange={v => setCampo('tno_bcf', v)} />
                  <CampoCad label="Alíquota" value={form?.tno_acf} width={90}
                    onChange={v => setCampo('tno_acf', v)} />
                  <div style={{ width: '100%', height: 0 }} />
                  <CampoCad label="Tributação (pessoa física)" value={form?.tno_tcf_f} options={opcoesCstCofins} width={340}
                    onChange={v => setCampo('tno_tcf_f', v)} />
                  <CampoCad label="Base (pessoa física)" value={form?.tno_bcf_f} width={90}
                    onChange={v => setCampo('tno_bcf_f', v)} />
                </Secao>

                <Secao titulo="CSLL" cor="#6b7280" corFundo="#fafafa" compact>
                  <CampoCad label="Tributação" value={form?.tno_tcs} options={OPCOES_ISENTO_TRIBUTADO} width={150}
                    onChange={v => setCampo('tno_tcs', v)} />
                  <CampoCad label="Base" value={form?.tno_bcs} width={90}
                    onChange={v => setCampo('tno_bcs', v)} />
                  <CampoCad label="Alíquota" value={form?.tno_acs} width={90}
                    onChange={v => setCampo('tno_acs', v)} />
                </Secao>

                <Secao titulo="Retém PIS/COFINS/CSLL (Vendas)" cor="#f07820" corFundo="#fff8f2" compact centralizar>
                  <CampoCad label="Retenção" value={form?.tno_rpc} options={OPCOES_RETEM_PIS_COFINS_CSLL} width={480}
                    onChange={v => setCampo('tno_rpc', v)} destaque />
                </Secao>

                <Secao titulo="IRRF" cor="#1a6ea8" corFundo="#f7faff" compact>
                  <CampoCad label="Tributação" value={form?.tno_tir} options={OPCOES_ISENTO_TRIBUTADO} width={150}
                    onChange={v => setCampo('tno_tir', v)} />
                  <CampoCad label="Base" value={form?.tno_bir} width={90}
                    onChange={v => setCampo('tno_bir', v)} />
                  <CampoCad label="Alíquota" value={form?.tno_air} width={90}
                    onChange={v => setCampo('tno_air', v)} />
                  <CampoCheckbox label="Retém" checked={form?.tno_rir === 'S'} width={70}
                    onChange={v => setCampo('tno_rir', v ? 'S' : 'N')} />
                </Secao>

                <Secao titulo="INSS" cor="#6b7280" corFundo="#fafafa" compact>
                  <CampoCad label="Tributação" value={form?.tno_tin} options={OPCOES_ISENTO_TRIBUTADO} width={150}
                    onChange={v => setCampo('tno_tin', v)} />
                  <CampoCad label="Base" value={form?.tno_bin} width={90}
                    onChange={v => setCampo('tno_bin', v)} />
                  <CampoCad label="Alíquota" value={form?.tno_ain} width={90}
                    onChange={v => setCampo('tno_ain', v)} />
                  <CampoCheckbox label="Retém" checked={form?.tno_rin === 'S'} width={70}
                    onChange={v => setCampo('tno_rin', v ? 'S' : 'N')} />
                  <CampoCad label="Vl. Mínimo" value={form?.tno_min} width={90}
                    onChange={v => setCampo('tno_min', v)} />
                  <CampoCheckbox label="Somar base e alíquota?" checked={form?.tno_sin === 'S'} width={150}
                    onChange={v => setCampo('tno_sin', v ? 'S' : 'N')} />
                </Secao>

                <Secao titulo="ISSQN" cor="#f07820" corFundo="#fff8f2" compact>
                  <CampoCad label="Tributação" value={form?.tno_tis} options={OPCOES_ISENTO_TRIBUTADO} width={150}
                    onChange={v => setCampo('tno_tis', v)} />
                  <CampoCad label="Base" value={form?.tno_bis} width={90}
                    onChange={v => setCampo('tno_bis', v)} />
                  <CampoCad label="Alíquota" value={form?.tno_ais} width={90}
                    onChange={v => setCampo('tno_ais', v)} />
                  <CampoCheckbox label="Retém" checked={form?.tno_ris === 'S'} width={70}
                    onChange={v => setCampo('tno_ris', v ? 'S' : 'N')} />
                  <div className="field-cad" style={{ width: 340 }}>
                    <label style={ESTILO_LABEL}>Município Base</label>
                    <CidadeSelect
                      codValue={cidadeSel.cod}
                      desValue={cidadeSel.des}
                      ibgeValue={cidadeSel.ibge}
                      ufValue={cidadeSel.uf}
                      onChange={(cod, des, ibge, uf) => {
                        setCidadeSel({ cod, des, ibge, uf })
                        setCampo('tno_cidco1', cod)
                      }}
                    />
                  </div>
                </Secao>

                <Secao titulo="DIFAL / FCP / IBPT" cor="#1a6ea8" corFundo="#f7faff" compact>
                  <CampoCad label="DIFAL — Tributação" value={form?.tno_dif} options={OPCOES_ISENTO_TRIBUTADO_NUM} width={150}
                    onChange={v => setCampo('tno_dif', v)} />
                  <CampoCad label="FCP — Tributação" value={form?.tno_fcp} options={OPCOES_ISENTO_TRIBUTADO_NUM} width={150}
                    onChange={v => setCampo('tno_fcp', v)} />
                  <CampoCad label="Alíquota IBPT" value={selecionado?.tno_alitri} width={110} />
                </Secao>
              </div>
            )}

            {form && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: '1rem' }}>
                <button className="btn btn-primary" onClick={modoCriar ? criar : salvar} disabled={salvando}>
                  {salvando ? (modoCriar ? 'Criando...' : 'Salvando...') : (modoCriar ? 'Criar natureza' : 'Salvar alterações')}
                </button>
                {modoCriar && (
                  <button className="btn btn-sm" onClick={cancelarCriacao} style={{ color: '#6b7280' }}>
                    Cancelar
                  </button>
                )}
                {msgSalvar && (
                  <span style={{
                    fontSize: '0.8rem', fontWeight: 600, padding: '0.35rem 0.8rem', borderRadius: 6,
                    background: msgSalvar.startsWith('Erro') ? '#fee2e2' : '#d1fae5',
                    color: msgSalvar.startsWith('Erro') ? '#991b1b' : '#065f46',
                  }}>
                    {msgSalvar}
                  </span>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
